module.exports = __webpack_public_path__ + "media/images/tc_logo-8eb99090e8375538ceb2565d482ef990.gif";